import * as yup from 'yup';
import styled, { withTheme } from 'styled-components';

import {
  FovFieldError,
  FovInput,
  FovModal,
  FovSelect,
  VerticalSpacer,
} from 'components';

import { allRoles } from 'components/generic/ProtectedContent';
import { FovButton } from 'components/generic';

import { Formik, Field } from 'formik';
import { useRef, Fragment, useCallback } from 'react';
import { ButtonContainer } from 'pages/ModelCanvas/SideMenus/Publish/publishStyles';

import { createUserAdmin } from 'store/actions/admin';
import { useDispatch } from 'react-redux';
import { useCookies } from 'react-cookie';

const InputContainer = styled('div')`
    max-width: 25rem;
`;


export const schema = yup.object().shape({
  email: yup
    .string().required('Email is required.'),

  role: yup
    .string()
    .trim()
    .default('registered')
    .optional()
    .nullable(),

  firstName: yup
    .string()
    .trim()
    .optional()
    .nullable(),

  lastName: yup
    .string()
    .trim()
    .optional()
    .nullable(),
});

const defaults = {
  email: '',
  firstName: '',
  lastName: '',
  role: 'registered',
};

const AddUserForm = withTheme(props => {
  const { isVisible, onClose } = props;
  const formikRef = useRef();
  const dispatch = useDispatch();
  const [ cookies ] = useCookies([ 'userAuth' ]);
  const token = cookies.archvision_token;

  const setRef = form => {
    if (!formikRef.current) {
      formikRef.current = form;
    }
  };

  const handleSubmit = useCallback(args => {
    const { values, setSubmitting } = args;

    const payload = {
      email: values.email,
      firstName: values.firstName || undefined,
      lastName: values.lastName || undefined,
      role: values.role || 'registered',
    };

    dispatch(createUserAdmin(token, payload))
      .finally(() => {
        setSubmitting(false);
        onClose();
      });
  }, []);

  const capitalize = s =>
  String(s)
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, c => c.toUpperCase());

  return (
    <FovModal
      title='Add a new user'
      visible={isVisible}
      onClose={onClose}
    >
      <Fragment>
        <Formik
          initialValues={defaults}
          validationSchema={schema}
          onSubmit={(values, handlers) => {
            const { setSubmitting } = handlers;
            handleSubmit({ values, setSubmitting });
          }}
          validateOnChange={true}
        >
          {form => (
            <Fragment>
              {setRef(form)}

              Email*
              <Field type='text' name='email'>
                {data => (
                  <InputContainer>
                    <FovInput
                      value={data.field.value}
                      placeholder=''
                      {...data.field}
                      onChange={e => {
                        const newVal = e.target.value;
                        form.setFieldValue(data.field.name, newVal);
                      }}
                    />
                  </InputContainer>
                )}
              </Field>
              <FovFieldError name='email' />
              <VerticalSpacer size={10} />

              Role
              <Field name='role'>
                {data => (
                  <InputContainer>
                    <FovSelect
                      value={data.field.value}
                      onChange={eOrVal => {
                        const next =
                          eOrVal?.target?.value ??
                          eOrVal?.value ??
                          eOrVal;
                        form.setFieldValue(data.field.name, next);
                      }}
                    >
                      {allRoles.map(r => (
                        <option key={r} value={r}>
                          {capitalize(r)}
                        </option>
                      ))}
                    </FovSelect>
                  </InputContainer>
                )}
              </Field>
              <FovFieldError name='role' />

              <VerticalSpacer size={10} />

              First Name (optional)
              <Field type='text' name='firstName'>
                {data => (
                  <InputContainer>
                    <FovInput
                      value={data.field.value}
                      placeholder=''
                      {...data.field}
                      onChange={e => {
                        const newVal = e.target.value;
                        form.setFieldValue(data.field.name, newVal);
                      }}
                    />
                  </InputContainer>
                )}
              </Field>
              <FovFieldError name='firstName' />

              <VerticalSpacer size={10} />

              Last Name (optional)
              <Field type='text' name='lastName'>
                {data => (
                  <InputContainer>
                    <FovInput
                      value={data.field.value}
                      placeholder=''
                      {...data.field}
                      onChange={e => {
                        const newVal = e.target.value;
                        form.setFieldValue(data.field.name, newVal);
                      }}
                    />
                  </InputContainer>
                )}
              </Field>
              <FovFieldError name='lastName' />

              <VerticalSpacer size={16} />

              <ButtonContainer>
                <FovButton
                  type='submit'
                  disabled={form.isSubmitting}
                  onClick={form.handleSubmit}
                >
                  Save User
                </FovButton>
              </ButtonContainer>

            </Fragment>
          )}
        </Formik>
      </Fragment>
    </FovModal>
  );
});

export { AddUserForm };
